import { Form } from '@/components';
import { useTranslation } from 'react-i18next';
import { useCommunityLookupSource } from '@/views';
import { isArray } from 'lodash';

interface Props {
  name: string;
  clientId?: string | string[];
  mode?: 'multiple';
  required?: boolean;
}

export function ReportingCommunitySelect(props: Props) {
  const { name, clientId, required, mode } = props;
  const communitiesDataSource = useCommunityLookupSource(clientId ?? false);
  const { t } = useTranslation();

  return (
    <Form.AsyncSelect
      key={isArray(clientId) ? clientId?.join() : clientId}
      name={name}
      dataSource={communitiesDataSource}
      mode={mode}
      preload
      maxTagCount={2}
      maxTagTextLength={10}
      required={required}
      selectAll={{
        selectAllLabel: t('reports.homeStatus.selectAll'),
        unselectAllLabel: t('reports.homeStatus.unselectAll'),
      }}
    />
  );
}
